import React from 'react';

const SuperAdminSubmittedSheet = () => {
    return (
        <div className="view-submitted-sheets-container">
            <div className="content-section">
                <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px", fontFamily: "Arial, sans-serif" }}>
                    Where to view the submitted timesheets?
                </h3>  
                <p className="description">
                    Keep track of all submitted sheets in one place. This table displays details of the submissions for easy review and follow-ups.
                </p>
            
                <p className="closing-text">
                    Use this table to quickly access submission details and their current status. For further actions or edits, reach out to the respective stakeholders.
                </p>
                
                <h4 className="section-heading">Steps to Approve or Reject Submitted Sheets</h4>
                <p className="description">
                    <strong>Step 1:</strong> Select the submitted sheet and choose the employee's submitted timesheet. You will then see both the <strong>Approve</strong> and <strong>Reject</strong> buttons.
                </p>
                <p className="description">
                    <strong>Step 2:</strong> Click on the <strong>Approve</strong> button to approve the timesheet.
                </p>
                
                <img
                    className="placeholder-image"
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737466428/Screenshot_2025-01-21_153124_qkuxud.png"
                    alt="Employee Table Screenshot"
                    style={{ maxWidth: "60%", height: "auto", float: "left", margin: "10px 20px 10px 0" }}
                />
                
                <div style={{ clear: "both" }}></div>
                
                <h4 className="section-heading">Submitted Timesheet Details</h4>
                <p className="description">
                    Once a timesheet is submitted, it is stored in the system for review and approval. Below are the key details available in the submitted timesheet record:
                </p>
                <ul className="description">
                    <li><strong>Timesheet ID:</strong> A unique identifier for tracking the submitted timesheet.</li>
                    <li><strong>Employee Name:</strong> The name of the employee who submitted the timesheet.</li>
                    <li><strong>Total Hours:</strong> The total billable hours recorded in the timesheet.</li>
                    <li><strong>Status:</strong> Submitted (Pending Approval).</li>
                    <li><strong>Submission Date:</strong> The date when the timesheet was submitted.</li>
                </ul>
                
                <p className="description">
                    <strong>Tip:</strong> Once the sheet is submitted, it awaits approval from the designated manager or admin.
                </p>
                <p className="description">
                    <strong>Note:</strong> If the timesheet is submitted, the employee will receive an email notification confirming the submission.
                </p>
                <p className="description">
                    <strong>Additional Information:</strong> You can also navigate to the <strong>Notifications</strong> section or check the email link for further details regarding the submission status.
                </p>
            </div>
            <style jsx>{`
                .view-submitted-sheets-container {
                    padding: 20px;
                    font-family: Arial, sans-serif;
                }
                .content-section {
                    max-width: 1200px;
                    margin: 0 auto;
                }
                .description, .closing-text {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #4F4F4F;
                    margin-bottom: 20px;
                }
                .section-heading {
                    font-size: 18px;
                    font-weight: 400;
                    color: #000000;
                    margin-bottom: 10px;
                }
                .submitted-sheets-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 20px;
                }
                .submitted-sheets-table th, .submitted-sheets-table td {
                    border: 1px solid #ddd;
                    padding: 8px;
                    text-align: left;
                }
                .table-wrapper {
                    overflow-x: auto;
                    -webkit-overflow-scrolling: touch;
                }
                .placeholder-image {
                    max-width: 60%;
                    height: auto;
                    float: left;
                    margin: 10px 20px 10px 0;
                }
            `}</style>
        </div>
    );
};

export default SuperAdminSubmittedSheet;
